/*
  TP cart drawer upgrades (where body has data-tp-cart="v2": every page, set in theme.liquid).
  - Add to cart waits for Kaching on products with a deal, so the free gifts are never skipped (see "wait for Kaching").
  - Opens the drawer the moment Add to cart is pressed, with a placeholder where the new line will
    appear, instead of after the server answers (~0.6 s). The checkout button waits for the real cart.
  - Skips Dawn's second fetch of the drawer right after an add (the add response already carries it).
  - The same set added twice is merged before it shows: one keyboard line with the summed quantity
    (2 + 2 = 4, Kaching prices it by quantity) and one set of free gifts.
  - The banner names the set: "Trader Duo Set · you save $X", from the keyboard count (1 Solo, 2 Duo, 3+ Pro)
    and Kaching's deal settings (read on product
    pages and kept in localStorage per deal, so the drawer on other pages knows them too).
  - The Complete Trading Framework (SKU TP-LIB-ALL) contains Levels I, II and III: when it is in the cart, single
    levels (TP-FND, TP-EXE, TP-MAS and the Framework's LV 1-3 options) are taken out quietly, and Selleasy stops
    suggesting them. It also contains the Trading Journal, so a paid journal line goes too.
  - Digital products (no shipping: e-books, journal, MT5 panel) are kept to one copy: quantity 1, and when the
    same product is in the cart twice (e.g. the free MT5 panel from a black and from a pink keyboard set, or a
    free gift next to a paid line) the free line stays and the others go. Level I/II/III and the Framework's
    LV 1-3 options count as the same e-book. Selleasy stops suggesting digital products already in the cart.
  - Selleasy sometimes renders its widget once per matching offer (black + pink keyboard): only the first shows.
  - A free gift taken out as a duplicate (e.g. the Trading Journal from both the Complete Framework and the Duo
    set) is remembered for the tab (sessionStorage tp-cd-spare). If the copy that stayed leaves later (Duo -> Solo
    drops its gift) while the spare's own set is still in the cart, the spare is added back, still free.
  - The desk mat and e-book offers come from Selleasy (its "Cart Upsell for Pad and EBook" offer, mat first),
    restyled in tp-cart.css; there is no mat card of our own any more.
  - Animations: rows ease in when the drawer opens, the added item glides in, the total counts to its
    new value.
  Note: Liquid HTML-escapes line item properties, so the Kaching JSON in the data script arrives as
  &quot;...; kp() decodes it.
  Cart lines come from <script class="tp-cd-data"> in snippets/cart-drawer.liquid.
*/
(function () {
  if (document.body.getAttribute('data-tp-cart') !== 'v2') return;

  var addingTimer = null;
  var lastRender = 0;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function drawer() { return document.querySelector('cart-drawer'); }
  function stopAdding() {
    clearTimeout(addingTimer);
    var d = drawer();
    if (d) d.classList.remove('tp-adding');
  }
  function startAdding() {
    var d = drawer();
    if (!d || typeof d.open !== 'function') return;
    d.classList.add('tp-adding');
    if (!d.classList.contains('active')) d.open();
    clearTimeout(addingTimer);
    addingTimer = setTimeout(stopAdding, 8000);
  }

  // ---------- data ----------
  function parseJSON(text) { try { return JSON.parse(text); } catch (e) { return null; } }
  // localStorage can be missing or throw (private mode, blocked site data): never let that break the cart
  function load(key) { try { return parseJSON(localStorage.getItem(key) || ''); } catch (e) { return null; } }
  function save(key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {} }
  // the desk mat offer now comes from Selleasy; clear the old cache of our own mat card
  try { localStorage.removeItem('tp-cd-mat'); } catch (e) {}
  function readData(root) {
    var el = root && root.querySelector('script.tp-cd-data');
    return (el && parseJSON(el.textContent)) || [];
  }
  function dataFromHtml(html) {
    if (!html) return [];
    return readData(new DOMParser().parseFromString(html, 'text/html'));
  }
  function unescapeHtml(s) {
    return String(s).replace(/&quot;/g, '"').replace(/&#39;|&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
  }
  function kp(item) {
    if (!item || !item.p) return null;
    var v = parseJSON(item.p);
    if (!v || typeof v !== 'object') v = parseJSON(unescapeHtml(item.p));
    return v && typeof v === 'object' ? v : null;
  }
  // Kaching deal settings by deal id (its nanoId, the "deal" in each line's properties). Product pages
  // carry them in the head; they're kept in localStorage so the drawer on other pages has them too.
  var KC_KEY = 'tp-cd-kc';
  var kcStore = null;
  function kcAll() {
    if (kcStore) return kcStore;
    kcStore = load(KC_KEY) || {};
    var changed = false;
    Array.prototype.forEach.call(document.querySelectorAll('script.kaching-bundles-deal-block-settings'), function (el) {
      var c = parseJSON(el.textContent);
      if (!c || !c.nanoId) return;
      kcStore[c.nanoId] = {
        dealBars: (c.dealBars || []).map(function (b) { return { id: b.id, title: b.title, quantity: b.quantity }; }),
        checkboxUpsellsEnabled: c.checkboxUpsellsEnabled,
        checkboxUpsells: c.checkboxUpsells ? { upsells: c.checkboxUpsells.upsells || [] } : null,
        otherProductHandles: c.otherProductHandles || []
      };
      changed = true;
    });
    if (changed) save(KC_KEY, kcStore);
    return kcStore;
  }
  function kcfg(deal) { return (deal && kcAll()[deal]) || null; }
  function moneyFormat() {
    var el = document.getElementById('kaching-bundles-config') || document.querySelector('script.kaching-bundles-config');
    var c = el ? parseJSON(el.textContent) : null;
    return (c && c.moneyFormat) || '${{amount}}';
  }
  function money(n) {
    var s = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return moneyFormat().replace(/\{\{\s*amount[^}]*\}\}/, s);
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // ---------- merge repeated sets ----------
  function mergePlan(items) {
    var groups = {}, updates = {}, changed = false;
    items.forEach(function (it) {
      var p = kp(it);
      if (p && p.main) (groups[it.v] = groups[it.v] || []).push(it);
    });
    Object.keys(groups).forEach(function (v) {
      var group = groups[v];
      if (group.length < 2) return;
      var linesOf = function (id, key) {
        return items.filter(function (it) { var p = kp(it); return p && !p.main && p.id === id && p[key]; });
      };
      // keep the set with the most free gifts (the bigger deal); ties keep the first one added
      var survivor = group.slice().sort(function (a, b) {
        return linesOf(kp(b).id, 'gift').length - linesOf(kp(a).id, 'gift').length;
      })[0];
      var sid = kp(survivor).id;
      var total = group.reduce(function (n, it) { return n + it.q; }, 0);
      updates[survivor.k] = total;
      var keptUpsells = linesOf(sid, 'checkboxUpsell');
      group.forEach(function (it) {
        if (it === survivor) return;
        var id = kp(it).id;
        updates[it.k] = 0;
        linesOf(id, 'gift').forEach(function (g) { updates[g.k] = 0; });
        linesOf(id, 'checkboxUpsell').forEach(function (u) {
          var twin = keptUpsells.filter(function (k) { return k.v === u.v; })[0];
          if (!twin) return; // no matching add-on in the kept set: leave this line as it is
          updates[twin.k] = (updates[twin.k] != null ? updates[twin.k] : twin.q) + u.q;
          updates[u.k] = 0;
        });
      });
      changed = true;
    });
    return changed ? updates : null;
  }

  // ---------- e-book library: the Complete Framework replaces single levels ----------
  var LIB_ALL = ['TP-LIB-ALL'];
  var LIB_SINGLE = ['TP-FND', 'TP-EXE', 'TP-MAS', 'TP-LIB-LV1', 'TP-LIB-LV2', 'TP-LIB-LV3'];
  var LIB_SINGLE_HANDLES = ['level-i-foundations', 'level-ii-execution', 'level-iii-mastery', 'trading-journal'];
  var JOURNAL = 'TP-JRNL';
  // Free = priced 0 now. A Kaching gift line keeps its "gift" property when its set stops qualifying (Duo -> Solo)
  // but is then charged, so the price decides; the property only counts when the price isn't known.
  function isFree(it) { var p = kp(it); return it.f === 0 || (typeof it.f !== 'number' && !!(p && p.gift)); }
  function hasComplete(items) {
    return items.some(function (it) { return it.q > 0 && LIB_ALL.indexOf(it.s) > -1; });
  }
  function libraryPlan(items) {
    if (!hasComplete(items)) return null;
    var updates = null;
    items.forEach(function (it) {
      var covered = LIB_SINGLE.indexOf(it.s) > -1 || (it.s === JOURNAL && !isFree(it));
      if (it.q > 0 && covered) { updates = updates || {}; updates[it.k] = 0; }
    });
    return updates;
  }

  // ---------- digital products: one copy each, the free line wins ----------
  var SAME_BOOK = { 'TP-LIB-LV1': 'TP-FND', 'TP-LIB-LV2': 'TP-EXE', 'TP-LIB-LV3': 'TP-MAS' };
  function bookKey(it) { return it.s ? (SAME_BOOK[it.s] || it.s) : 'v' + it.v; }
  function digitalPlan(items) {
    var groups = {}, updates = null;
    items.forEach(function (it) {
      if (it.q < 1 || it.d !== 1 || it.h === PROT) return;
      var key = bookKey(it);
      (groups[key] = groups[key] || []).push(it);
    });
    Object.keys(groups).forEach(function (key) {
      var lines = groups[key].slice().sort(function (a, b) {
        return (isFree(b) ? 1 : 0) - (isFree(a) ? 1 : 0) || (a.f || 0) / a.q - (b.f || 0) / b.q;
      });
      lines.forEach(function (it, n) {
        var want = n === 0 ? 1 : 0;
        if (it.q !== want) { updates = updates || {}; updates[it.k] = want; }
        if (!want) keepSpare(it);
      });
    });
    return updates;
  }

  // ---------- free gifts taken out as duplicates come back when the copy that stayed goes ----------
  var SPARE = 'tp-cd-spare';
  function spares() {
    try { return parseJSON(sessionStorage.getItem(SPARE) || '') || []; } catch (e) { return []; }
  }
  function setSpares(list) {
    try { if (list.length) sessionStorage.setItem(SPARE, JSON.stringify(list)); else sessionStorage.removeItem(SPARE); } catch (e) {}
  }
  function keepSpare(it) {
    var p = kp(it);
    if (!p || !p.gift || !p.id || !isFree(it)) return;
    var list = spares().filter(function (sp) { return !(sp.id === p.id && sp.key === bookKey(it)); });
    list.push({ id: p.id, key: bookKey(it), v: it.v, p: JSON.stringify(p) });
    setSpares(list);
  }
  // The page's fetch is wrapped by an app that raises the set's quantity when one of its gifts is added on its
  // own (seen with the Complete Framework: 1 -> 2). A fetch from a blank same-origin frame isn't wrapped.
  var rawFrame = null;
  function rawPost(url, body) {
    if (!rawFrame || !rawFrame.isConnected) {
      rawFrame = document.createElement('iframe');
      rawFrame.hidden = true;
      rawFrame.setAttribute('aria-hidden', 'true');
      rawFrame.tabIndex = -1;
      document.body.appendChild(rawFrame);
    }
    var w = rawFrame.contentWindow, f = (w && w.fetch) || window.fetch;
    return f.call(w || window, location.origin + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  var restoring = false;
  function restoreGifts(d, items) {
    if (restoring || fixing || typeof d.renderContents !== 'function') return;
    var list = spares();
    if (!list.length) return;
    var keep = [], add = null;
    list.forEach(function (sp) {
      var setIn = items.some(function (it) { var p = kp(it); return it.q > 0 && p && p.main && p.id === sp.id; });
      if (!setIn) return;
      // only a free copy counts: a gift whose set stopped qualifying stays in the cart but is charged
      var has = items.some(function (it) { return it.q > 0 && it.d === 1 && bookKey(it) === sp.key && isFree(it); });
      if (has || add) keep.push(sp); else add = sp;
    });
    setSpares(keep);
    if (!add) return;
    restoring = true;
    rawPost('/cart/add.js', { items: [{ id: add.v, quantity: 1, properties: { __kaching_bundles: add.p } }] })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        // only keep it if it really came back free; otherwise take it out again
        var line = (cart.items || []).filter(function (i) {
          return i.variant_id === add.v && i.properties && i.properties.__kaching_bundles === add.p;
        })[0];
        if (line && line.final_line_price > 0) return rawPost('/cart/change.js', { id: line.key, quantity: 0 });
      })
      .then(function () { return fetch('/?sections=' + SECTIONS).then(function (r) { return r.json(); }); })
      .then(function (sections) {
        if (sections && sections['cart-drawer']) d.renderContents({ sections: sections, __tpMerged: true });
      })
      .catch(function () {})
      .then(function () { restoring = false; });
  }
  function applyPlan(items, plan) {
    if (!plan) return items;
    return items.map(function (it) {
      if (!(it.k in plan)) return it;
      var c = {}; Object.keys(it).forEach(function (x) { c[x] = it[x]; });
      c.q = plan[it.k];
      return c;
    });
  }
  // Library and digital rules together, worked out on the cart as the earlier steps leave it.
  function tidyPlan(items) {
    var a = libraryPlan(items), b = digitalPlan(applyPlan(items, a));
    if (!a && !b) return null;
    var out = {};
    [a, b].forEach(function (p) { if (p) Object.keys(p).forEach(function (k) { out[k] = p[k]; }); });
    return out;
  }
  // Everything the cart should change before it is shown: merged sets, covered e-books and one copy of each
  // digital product, in one update.
  function cartPlan(items) {
    var a = mergePlan(items), b = tidyPlan(applyPlan(items, a));
    if (!a && !b) return null;
    var out = {};
    [a, b].forEach(function (p) { if (p) Object.keys(p).forEach(function (k) { out[k] = p[k]; }); });
    return out;
  }
  // While the Complete Framework is in the cart, Selleasy's single-level cards are hidden (and the whole
  // widget when nothing else is left in it).
  function hideCoveredOffers(d, items) {
    var all = d.querySelectorAll('lb-upsell-widget');
    // one widget only: Selleasy can render one per matching offer (black + pink keyboard in the cart)
    Array.prototype.forEach.call(all, function (w, n) {
      var want = n === 0 ? '' : 'none';
      if (w.style.display !== want) w.style.display = want;
    });
    var lb = all[0];
    if (!lb) return;
    var hide = hasComplete(items), shown = 0;
    var owned = items.filter(function (it) { return it.q > 0 && it.d === 1; }).map(function (it) { return it.h; });
    Array.prototype.forEach.call(lb.querySelectorAll('lb-upsell-flat-card'), function (card) {
      var h = card.getAttribute('lb-product-handle');
      var covered = (hide && LIB_SINGLE_HANDLES.indexOf(h) > -1) || owned.indexOf(h) > -1;
      var want = covered ? 'none' : '';
      if (card.style.display !== want) card.style.display = want;
      if (!covered) shown++;
    });
    if (shown) lb.removeAttribute('data-tp-empty'); else lb.setAttribute('data-tp-empty', '');
  }
  // A cart that already holds both (added another way, e.g. on the cart page): fix it once, quietly.
  var fixing = false;
  function fixLibrary(d, items) {
    var plan = tidyPlan(items);
    if (!plan || fixing || typeof d.renderContents !== 'function') return;
    fixing = true;
    post('/cart/update.js', { updates: plan, sections: SECTIONS, sections_url: location.pathname })
      .then(function (resp) {
        if (resp && resp.sections) { resp.__tpMerged = true; d.renderContents(resp); }
      })
      .catch(function () {})
      .then(function () { fixing = false; });
  }

  // ---------- set name in the banner ----------
  // The biggest set the main line's quantity reaches: 1 Solo, 2 Duo, 3 or more Pro.
  function setName(items) {
    var main = null;
    items.forEach(function (it) { var p = kp(it); if (p && p.main && (!main || it.q > main.q)) main = it; });
    var cfg = main && kcfg(kp(main).deal);
    if (!cfg || !cfg.dealBars || !cfg.dealBars.length) return '';
    // bars picked by variant (e-book levels, the Complete Framework): the bar the line was added with (Kaching
    // saves its id as "bar"); quantity bars (keyboard sets): the biggest one the quantity reaches
    var barId = kp(main).bar;
    var fit = barId ? cfg.dealBars.filter(function (b) { return b.id === barId && typeof b.quantity !== 'number'; })[0] : null;
    if (!fit) {
      var bars = cfg.dealBars.filter(function (b) { return typeof b.quantity === 'number'; })
        .sort(function (a, b) { return a.quantity - b.quantity; });
      fit = bars.filter(function (b) { return b.quantity <= main.q; }).pop() || bars[0];
    }
    var title = ((fit && fit.title) || '').replace(/\s+/g, ' ').trim();
    // titles like "{{product}}" are Kaching placeholders: show "Deal applied" instead
    return title.indexOf('{{') > -1 ? '' : title;
  }

  // ---------- apply to the drawer as it is now ----------
  function enhance() {
    var d = drawer();
    if (!d) return;
    var items = readData(d);
    var deal = d.querySelector('.tp-cd-deal');
    if (deal) {
      var name = setName(items);
      var text = name || 'Deal applied';
      if (deal.textContent !== text) deal.textContent = text;
    }
    hideCoveredOffers(d, items);
    fixLibrary(d, items);
    restoreGifts(d, items);
    tidyProtection(d, items);
    selleasyDots(d);
  }

  // ---------- shipping protection (snippets/tp-protection.liquid) ----------
  // The switch adds or removes the "shipping-protection" product; its cart line is hidden in the list.
  // It is taken out again when it is the only thing left in the cart, or when the toggle isn't offered
  // (EU/EEA visitors, product unavailable).
  var PROT = 'shipping-protection';
  var protBusy = false;
  function protectionSend(d, body) {
    protBusy = true;
    var box = d.querySelector('.tp-prot');
    if (box) box.classList.add('is-busy');
    body.sections = SECTIONS;
    body.sections_url = location.pathname;
    return post(body.items ? '/cart/add.js' : '/cart/change.js', body)
      .then(function (resp) {
        if (!resp || !resp.sections) throw new Error('protection failed');
        resp.__tpMerged = true;
        d.renderContents(resp);
      })
      .catch(function () {
        var b = d.querySelector('.tp-prot');
        if (b) { b.classList.remove('is-busy'); var i = b.querySelector('input'); if (i) i.checked = !i.checked; }
      })
      .then(function () { protBusy = false; });
  }
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.closest || !input.closest('.tp-prot')) return;
    var d = drawer(), box = input.closest('.tp-prot');
    if (!d || protBusy) { input.checked = !input.checked; return; }
    if (input.checked) protectionSend(d, { items: [{ id: Number(box.getAttribute('data-variant')), quantity: 1 }] });
    else if (box.getAttribute('data-key')) protectionSend(d, { id: box.getAttribute('data-key'), quantity: 0 });
  });
  function tidyProtection(d, items) {
    if (protBusy) return;
    var line = items.filter(function (it) { return it.h === PROT && it.q > 0; })[0];
    if (!line) return;
    var others = items.some(function (it) { return it.h !== PROT && it.q > 0; });
    if (!others || !d.querySelector('.tp-prot')) protectionSend(d, { id: line.k, quantity: 0 });
  }

  // ---------- Selleasy deals: picture and name add to the cart ----------
  // Selleasy opens a product preview popup on a tap on a card's picture or name. Inside the cart drawer that
  // popup comes out 0 px wide but still locks scrolling and covers the page, so the site looks frozen.
  // Catch those taps first (capture phase) and press the card's own Add button instead.
  function dealTap(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var hit = t.closest('lb-card-image, lb-card-title');
    if (!hit || !hit.closest('cart-drawer lb-upsell-widget')) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var card = hit.closest('lb-upsell-flat-card');
    var add = card && card.querySelector('.lb-button');
    if (add && add.getAttribute('aria-disabled') !== 'true' && !add.hasAttribute('disabled')) add.click();
  }
  document.addEventListener('click', dealTap, true);
  document.addEventListener('keydown', dealTap, true);

  // ---------- Selleasy deals: bigger picture on hover (mouse only) ----------
  // The deal pictures are small; with a mouse, hovering one shows it at up to 280 px just left of the panel,
  // over the dimmed page (outside the panel, so the card row can't clip it). Hidden on any scroll or redraw.
  var peek = null, peekFor = null;
  var canHover = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
  function peekHide() {
    if (peek) peek.classList.remove('is-on');
    peekFor = null;
  }
  function peekShow(img) {
    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (!inner) return;
    var box = inner.getBoundingClientRect();
    var size = Math.min(280, box.left - 32);
    if (size < 160) return;
    if (!peek) {
      peek = document.createElement('div');
      peek.className = 'tp-sl-peek';
      peek.setAttribute('aria-hidden', 'true');
      peek.appendChild(document.createElement('img'));
      document.body.appendChild(peek);
    }
    var src = (img.currentSrc || img.src || '').replace(/_\d+x\d+(\.[a-z]+)(\?|$)/i, '_800x800$1$2');
    if (peek.firstChild.getAttribute('src') !== src) peek.firstChild.src = src;
    var r = img.getBoundingClientRect();
    var top = Math.max(16, Math.min(window.innerHeight - size - 16, r.top + r.height / 2 - size / 2));
    peek.style.cssText = 'width:' + size + 'px;height:' + size + 'px;top:' + top + 'px;left:' + (box.left - size - 16) + 'px';
    peek.classList.add('is-on');
    peekFor = img;
  }
  document.addEventListener('mouseover', function (e) {
    if (!canHover || !canHover.matches) return;
    var t = e.target;
    var host = t && t.closest && t.closest('cart-drawer lb-upsell-widget lb-card-image');
    var img = host && host.querySelector('img');
    if (!img) { if (peekFor) peekHide(); return; }
    if (img !== peekFor) peekShow(img);
  });
  document.addEventListener('scroll', peekHide, true);
  document.addEventListener('click', peekHide, true);

  // ---------- Selleasy deals: swipe with dots ----------
  // Selleasy shows one card at a time in a scroll-snap row; its own dots are hidden (they don't follow the
  // swipe here), so ours go under the cards, in the review-dots style. Placed as the widget's last child.
  function dealCards(list) {
    return Array.prototype.filter.call(list.children, function (c) {
      return c.tagName === 'LB-UPSELL-FLAT-CARD' && c.style.display !== 'none';
    });
  }
  function markDots(list) {
    var lb = list.closest('lb-upsell-widget'), nav = lb && lb.querySelector('.tp-sl-dots');
    if (!nav || !list.clientWidth) return;
    var i = Math.round(list.scrollLeft / list.clientWidth);
    Array.prototype.forEach.call(nav.children, function (b, n) {
      var on = n === i ? 'true' : 'false';
      if (b.getAttribute('aria-current') !== on) b.setAttribute('aria-current', on);
    });
  }
  function selleasyDots(d) {
    var lb = d.querySelector('lb-upsell-widget');
    if (!lb) return;
    var list = lb.querySelector('.lb-carousel-products');
    var nav = lb.querySelector('.tp-sl-dots');
    var cards = list ? dealCards(list) : [];
    if (cards.length < 2) { if (nav) nav.remove(); return; }
    if (!nav || nav.childElementCount !== cards.length || nav.parentNode !== lb) {
      if (nav) nav.remove();
      nav = document.createElement('div');
      nav.className = 'tp-sl-dots';
      nav.setAttribute('role', 'group');
      nav.setAttribute('aria-label', 'More deals');
      cards.forEach(function (c, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Deal ' + (i + 1) + ' of ' + cards.length);
        b.addEventListener('click', function () {
          var l = lb.querySelector('.lb-carousel-products');
          if (l) l.scrollTo({ left: i * l.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        });
        nav.appendChild(b);
      });
      lb.appendChild(nav);
    }
    if (!list.__tpDots) {
      list.__tpDots = true;
      var ticking = false;
      list.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; markDots(list); });
      }, { passive: true });
    }
    markDots(list);
  }
  var queued = false;
  function queueEnhance() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; enhance(); });
  }

  // ---------- add to cart: wait for Kaching (free gifts) ----------
  // The Add to cart button works as soon as the page arrives, but Kaching only adds its set data (and with it
  // the free MT5 panel) about 2 s later, longer on phones. A press in that gap added a plain keyboard with no
  // gift. On products with a Kaching deal, a press before Kaching is ready now shows the button's spinner,
  // waits for Kaching (up to GIFT_WAIT ms), then adds. If Kaching never loads (blocked), the add still goes
  // through, with a hidden line property the shop sees in the order (customers don't see "_" properties).
  // Registered before "open at once" below, so the drawer only opens for the real add.
  var GIFT_WAIT = 6000;
  var GIFT_FIELD = 'properties[__kaching_bundles]';
  var dealCache = null;
  function kachingDeals() {
    if (dealCache) return dealCache;
    dealCache = [];
    Array.prototype.forEach.call(document.querySelectorAll('script.kaching-bundles-deal-block-settings'), function (el) {
      var d = parseJSON(el.textContent);
      if (d) dealCache.push(d);
    });
    return dealCache;
  }
  function kachingWanted(form) {
    var pidEl = form.querySelector('[name="product-id"]');
    var pid = pidEl ? String(pidEl.value) : '';
    if (!pid) return false;
    return kachingDeals().some(function (d) {
      if ((d.excludedProductIds || []).map(String).indexOf(pid) > -1) return false;
      if (d.blockVisibility === 'selected-products') return (d.selectedProductIds || []).map(String).indexOf(pid) > -1;
      return true;
    });
  }
  function busy(form, on) {
    var btn = form.querySelector('[type="submit"]');
    var spin = form.closest('product-form') && form.closest('product-form').querySelector('.loading__spinner');
    if (btn) {
      if (on) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
      else { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
    }
    if (spin) spin.classList.toggle('hidden', !on);
  }
  function submitAgain(form, submitter) {
    form.__tpGiftPass = true;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    form.__tpGiftPass = false;
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('product-form')) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (form.__tpGiftPass) return;
    if (form.__tpGiftWaiting) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (form.querySelector('[name="' + GIFT_FIELD + '"]') || !kachingWanted(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var submitter = e.submitter;
    form.__tpGiftWaiting = true;
    busy(form, true);
    var t0 = Date.now();
    (function check() {
      var ready = !!form.querySelector('[name="' + GIFT_FIELD + '"]');
      if (!ready && Date.now() - t0 < GIFT_WAIT) { setTimeout(check, 100); return; }
      form.__tpGiftWaiting = false;
      busy(form, false);
      var note = null;
      if (!ready) {
        note = document.createElement('input');
        note.type = 'hidden';
        note.name = 'properties[_Panel gift]';
        note.value = 'Not added: Kaching had not loaded';
        form.appendChild(note);
      }
      submitAgain(form, submitter);
      if (note) note.remove();
    })();
  }, true);

  // ---------- add to cart: open at once ----------
  // Capture phase: runs before Dawn's product-form handler, which then does the real add.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('product-form')) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    startAdding();
  }, true);

  // Add failed (sold out, limit): close the drawer so the form's own error message shows.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartError, function () {
      var d = drawer();
      stopAdding();
      if (d && typeof d.close === 'function') d.close();
    });
  }

  // ---------- animations ----------
  function lineKeys(root) {
    return Array.prototype.map.call(root.querySelectorAll('.cart-item [data-quantity-variant-id]'), function (el) {
      return el.getAttribute('data-quantity-variant-id') + ':' + el.value;
    });
  }
  function parseMoney(text) {
    var m = (text || '').match(/^([^\d]*)([\d,]+\.\d{2})(.*)$/);
    return m ? { pre: m[1], num: parseFloat(m[2].replace(/,/g, '')), post: m[3] } : null;
  }
  function countUp(el, fromText) {
    var from = parseMoney(fromText), to = parseMoney(el.textContent.trim());
    if (!from || !to || from.num === to.num) return;
    el.classList.remove('tp-bump'); void el.offsetWidth; el.classList.add('tp-bump');
    if (reduce) return;
    var t0 = performance.now(), dur = 450;
    (function frame(now) {
      var k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      var v = from.num + (to.num - from.num) * e;
      el.textContent = to.pre + v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + to.post;
      if (k < 1) requestAnimationFrame(frame);
    })(t0);
  }

  customElements.whenDefined('cart-drawer').then(function () {
    var CD = customElements.get('cart-drawer');
    var origRender = CD.prototype.renderContents;
    var origOpen = CD.prototype.open;

    // Closing hands focus back to whatever opened the drawer (Dawn's removeTrapFocus), and the browser scrolled
    // the page to it. Same focus, no scroll. Covers Dawn's other drawers and menus too.
    if (typeof window.removeTrapFocus === 'function' && !window.removeTrapFocus.__tp) {
      var origTrap = window.removeTrapFocus;
      window.removeTrapFocus = function (el) {
        origTrap();
        if (el && typeof el.focus === 'function') el.focus({ preventScroll: true });
      };
      window.removeTrapFocus.__tp = true;
    }

    CD.prototype.open = function () {
      if (!this.classList.contains('active')) {
        var self = this;
        this.classList.add('tp-opening');
        setTimeout(function () { self.classList.remove('tp-opening'); }, 900);
      }
      return origOpen.apply(this, arguments);
    };

    CD.prototype.renderContents = function (parsed) {
      var self = this;
      // Same set added twice, or the Complete Framework next to a single level: fix it on the server first,
      // then show the fixed cart.
      if (parsed && parsed.sections && !parsed.__tpMerged) {
        var plan = cartPlan(dataFromHtml(parsed.sections['cart-drawer']));
        if (plan) {
          startAdding();
          post('/cart/update.js', { updates: plan, sections: SECTIONS, sections_url: location.pathname })
            .then(function (resp) {
              if (!resp || !resp.sections) throw new Error('merge failed');
              resp.__tpMerged = true;
              self.renderContents(resp);
            })
            .catch(function () { parsed.__tpMerged = true; self.renderContents(parsed); });
          return;
        }
      }
      var before = lineKeys(this);
      var totalEl = this.querySelector('.totals__total-value');
      var oldTotal = totalEl ? totalEl.textContent.trim() : '';
      lastRender = Date.now();
      var out = origRender.apply(this, arguments);
      stopAdding();
      peekHide();
      Array.prototype.forEach.call(this.querySelectorAll('.cart-item'), function (row) {
        var input = row.querySelector('[data-quantity-variant-id]');
        var key = input ? input.getAttribute('data-quantity-variant-id') + ':' + input.value : '';
        if (key && before.indexOf(key) < 0) row.classList.add('tp-new');
      });
      var newTotal = this.querySelector('.totals__total-value');
      if (newTotal && oldTotal) countUp(newTotal, oldTotal);
      enhance();
      setTimeout(function () {
        Array.prototype.forEach.call(self.querySelectorAll('.cart-item.tp-new'), function (r) { r.classList.remove('tp-new'); });
      }, 1600);
      return out;
    };

    // Quantity changes, removals and app widgets redraw parts of the drawer: re-apply labels and offer.
    var d = drawer();
    if (d) new MutationObserver(queueEnhance).observe(d, { childList: true, subtree: true });
    enhance();
  });

  customElements.whenDefined('cart-drawer-items').then(function () {
    var CI = customElements.get('cart-drawer-items');
    var origUpdate = CI.prototype.onCartUpdate;
    CI.prototype.onCartUpdate = function () {
      var d = drawer();
      if ((d && d.classList.contains('tp-adding')) || Date.now() - lastRender < 1500) return Promise.resolve();
      return origUpdate.apply(this, arguments);
    };
  });
})();
